import React__default from 'react';
import { getAmountString, humanizeTermRange } from '../../helpers/humanization.js';

const approvalProbabilityMap = {
    high: {
        color: 'h-color-G100',
        title: 'Высокое',
    },
    medium: {
        color: 'h-color-O100',
        title: 'Среднее',
    },
    low: {
        color: 'h-color-R100',
        title: 'Низкое',
    },
};
const getMicrocreditsTerms = item => {
    const conditions = [];
    const { details, approvalProbability } = item;
    const { category } = approvalProbability;
    const approvalProbabilityData = approvalProbabilityMap[category];
    const { title, color } = approvalProbabilityData;
    category &&
        conditions.push({
            value: title,
            SOValue: React__default.createElement("span", { className: color }, title),
            description: 'Одобрение',
            key: 'approval',
        });
    const maxRange = getAmountString(details.amount.to, details.currency);
    conditions.push({ value: `до ${maxRange}`, description: 'Сумма', key: 'sum' });
    const termRange = humanizeTermRange(details.term, {
        termWithUnit: true,
        initialForm: true,
        prepositions: false,
    });
    conditions.push({ value: termRange, description: 'Срок', key: 'term' });
    return conditions;
};

export { getMicrocreditsTerms };
//# sourceMappingURL=microcredits.js.map
